import { createTheme } from "@mui/material/styles";
import { colors } from "colors";

// 87FFC1
// B044FF

const GREEN1 = "#87FFC1";
const GREEN2 = "#60B589";
const PURPLE = "#B044FF";
const BLACK = "#000000";
const WHITE = "#FFFFFC";
const LIGHT_GRAY = "#F5F5F5";
const DARK_GRAY = "#1A1A1A";


const lightTheme = createTheme({
  palette: {
    mode: "light",
    black: {
      main: BLACK,
      contrastText: WHITE,
    },
    formLabel: {
      main: "#6B6B6B",
    },
    primary: {
      main: GREEN1,
      contrastText: BLACK,
    },
    secondary: {
      main: PURPLE,
      contrastText: WHITE,
    },
    menuIcon: {
      main: BLACK,
    },
    background: {
      default: WHITE,
    },
    text: {
      main: BLACK,
    },
    conversationBackground: {
      default: WHITE,
      active: LIGHT_GRAY,
    },
    inputBackground: {
      main: WHITE,
    },
    inputText: {
      main: WHITE,
    },
    messageBackground: {
      main: LIGHT_GRAY,
    },
    modalBackground: {
      main: WHITE,
    },
  },
});

const darkTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: DARK_GRAY,
        },
      },
    },
  },
  palette: {
    mode: "dark",
    modalBackground: {
      main: DARK_GRAY,
    },
    formLabel: {
      main: "#C4C4C4",
    },
    messageBackground: {
      main: DARK_GRAY,
    },
    menuIcon: {
      main: WHITE,
    },
    conversationBackground: {
      default: BLACK,
      active: DARK_GRAY,
    },
    primary: {
      main: GREEN1,
      contrastText: BLACK,
    },
    secondary: {
      main: PURPLE,
      contrastText: WHITE,
    },
    inputBackground: {
      main: DARK_GRAY,
    },
    inputText: {
      main: WHITE,
    },
    text: {
      main: WHITE,
    },
    background: {
      default: BLACK,
    },
    black: {
      main: BLACK,
      contrastText: WHITE,
    },
  },
});

export { lightTheme, darkTheme };
